import { empApi } from "./client";

// Danh sách loại nghỉ phép
export const getLeaveTypesApi = () => empApi.get("/leaveType");

// Số ngày phép còn lại theo loại
export const getRemainingDaysApi = (leaveTypeCode) =>
  empApi.get("/leaveRequest/app/remainingDays", { leaveTypeCode });

// Tạo đơn nghỉ phép: { startDate, leaveTypeCode, reason, daysRequested }
export const createLeaveRequestApi = (body) =>
  empApi.post("/leaveRequest/app/employee", body);

// Danh sách đơn nghỉ của tôi
export const getLeaveRequestsApi = (params) =>
  empApi.get("/leaveRequest/app/employee", params);

// Chi tiết 1 đơn nghỉ
export const getLeaveRequestByIdApi = (id) =>
  empApi.get(`/leaveRequest/app/employee/${id}`);

// Cập nhật / xóa (chỉ khi còn chờ duyệt)
export const updateLeaveRequestApi = (id, body) =>
  empApi.put(`/leaveRequest/app/employee/${id}`, body);

export const deleteLeaveRequestApi = (id) =>
  empApi.del(`/leaveRequest/app/employee/${id}`);
